import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CarInsuranceIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none">
        <path
          d="M5.72 24.745H2.912Q1 25.127 1 27.04c0 1.275.638 1.913 1.913 2.04v16.455C2.913 48.469 4.19 50 6.74 50s3.826-1.53 3.826-4.464h29.847c0 2.933 1.276 4.464 3.827 4.464 2.55 0 3.826-1.53 3.826-4.464V29.082c1.403-.255 2.169-.893 2.169-2.169 0-1.275-.766-1.913-2.169-2.168h-2.678L39.776 14.03a2.9 2.9 0 00-2.424-1.276H13.628c-.893 0-1.786.51-2.169 1.403z"
          fill="#ffffff"
          className={classnames(styles.white, styles.defaultStrokeColor)}
          stroke="#000000"
          strokeWidth="1.5"
        />
        <path
          clipRule="evenodd"
          d="M40.796 33.419a3.16 3.16 0 013.189 3.188 3.16 3.16 0 01-3.189 3.189 3.16 3.16 0 01-3.189-3.189c0-1.785 1.531-3.188 3.19-3.188m-30.613 0a3.16 3.16 0 013.189 3.188 3.16 3.16 0 01-3.19 3.189 3.16 3.16 0 01-3.188-3.189c0-1.785 1.53-3.188 3.189-3.188"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
        <path
          d="M16.944 33.929h17.22m-17.22 3.826h17.22"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.75"
        />
        <path
          d="M10.184 24.745h30.612l-3.444-7.398c-.128-.51-.638-.766-1.148-.766H14.903q-.765 0-1.148.766z"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinejoin="round"
          strokeWidth="0.75"
        />
        <path
          d="M6.995 29.592h36.99"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.75"
        />

        <path
          clipRule="evenodd"
          d="M24.4 3.699L25.546 0l1.148 3.699h3.954L27.46 5.995l1.275 3.699-3.189-2.296-3.188 2.296 1.275-3.7L20.445 3.7zm-12.755 0L12.793 0l1.147 3.699h3.955l-3.19 2.296 1.276 3.699-3.188-2.296-3.19 2.296 1.276-3.7L7.69 3.7zm25.509 0L38.302 0l1.148 3.699h3.954l-3.189 2.296 1.276 3.699-3.189-2.296-3.188 2.296 1.275-3.7L33.2 3.7z"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
}
